import ERPSelectionTile from './ERPSelectionTile';

export default ERPSelectionTile;
